import isArray from "lodash/isArray";
import isObject from "lodash/isObject";

const mergeDeep = (target, source) => {
  let output = isArray(target) ? [...source] : { ...target };
  if (isObject(source) && !isArray(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key]) && isObject(target[key])) {
        if (!(key in target)) {
          output = { ...output, [key]: source[key] };
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        output = { ...output, [key]: source[key] };
      }
    });
  }

  return output;
};

export default mergeDeep;
